import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";
import { PlaceFormValues } from "pages/Places/PlaceForm/PlaceForm";

const create = (data: PlaceFormValues): AxiosPromise => {
  return api.post(endpoints.BLOCKED.CREATE(), data);
};

const fetch = (skip: number, take: number, searchPhrase: string = ""): AxiosPromise<BaseApiPaging<BlockedApi>> => {
  return api.get<BaseApiPaging<BlockedApi>>(endpoints.BLOCKED.GET(skip, take, searchPhrase));
};

const deleteBlocked = (id: number): Promise<void> => {
  return api.delete(endpoints.BLOCKED.DELETE(id));
};

export const blockedApi = {
  create,
  fetch,
  delete: deleteBlocked,
};

export interface BlockedApi {
  id: number;
  identifier: string;
  reason: string;
  type: number;
}
